import { HorizontalDividerAdapter } from "./HorizontalDivider";

export { HorizontalDividerAdapter as HorizontalDivider };
